import { apiGet, apiPost } from './client';

export type AlarmBroadcastTargetScope = 'FIELD' | 'DEVICE';

export interface AlarmBroadcastRouteSummary {
  channel: 'mqtt' | 'legacy' | string;
  gid: string | null;
  lora_channel: string | null;
  topic: string | null;
}

export interface AlarmBroadcastTarget {
  device_uid: string;
  device_name: string;
  r_id: string | null;
  s_id: string | null;
  device_state: string;
  is_alarm_broadcast_enabled?: boolean;
  target_type?: 'IOT' | 'CCTV' | 'MEDIA' | (string & {});
  delivery_type?: string;
  source_kinds?: ('SYSTEM' | 'RECORDING')[];
  supported_alert_types?: string[];
  camera_uid?: string | null;
  media_server_id?: string | null;
  media_camera_id?: string | null;
  routes: AlarmBroadcastRouteSummary[];
}

export interface AlarmBroadcastOptionsResponse {
  field_uid: string;
  erp_id: string;
  alert_types: string[];
  camera_alert_types?: string[];
  hidden_alert_types?: string[];
  preset_groups?: { name: string; actions: { alert_type: string; name: string }[] }[];
  targets: AlarmBroadcastTarget[];
}

export interface AlarmBroadcastDelivery {
  command_id?: string;
  channel: 'mqtt' | 'legacy' | 'none' | string;
  camera_uid: string | null;
  request_uid: string | null;
  device_uid: string | null;
  device_name: string;
  r_id: string | null;
  s_id: string | null;
  status: 'ACCEPTED' | 'SENT' | 'QUEUED' | 'SKIPPED' | 'FAILED' | 'UNKNOWN' | string;
  gid: string | null;
  lora_channel: string | null;
  topic: string | null;
  reason: string | null;
}

export interface AlarmBroadcastSendResponse {
  field_uid: string;
  erp_id: string;
  target: {
    scope: AlarmBroadcastTargetScope;
    device_uid: string | null;
  };
  alert: {
    type: string | null;
    value: number | null;
  };
  summary: {
    kafka_queued?: number;
    kafka_failed?: number;
    mqtt_sent: number;
    legacy_queued: number;
    skipped: number;
    failed: number;
    camera_accepted?: number;
    camera_failed?: number;
    camera_unknown?: number;
  };
  deliveries: AlarmBroadcastDelivery[];
}

export interface SendAlarmBroadcastInput {
  provider?: 'V1' | 'V2';
  idempotency_key?: string;
  device_uid?: string | null;
  field_uid: string;
  sacon_tx_type: string;
  target_scope: AlarmBroadcastTargetScope;
}

/** 알람방송 위젯 옵션을 조회합니다. */
export function fetchAlarmBroadcastOptions(fieldUid: string, _provider: 'V1' | 'V2' = 'V2') {
  return apiGet<AlarmBroadcastOptionsResponse>({
    path: '/alarm-broadcast/options',
    version: 'V2',
    query: { field_uid: fieldUid, preview: true },
  });
}

/** 알람방송 전송을 요청합니다. */
export function sendAlarmBroadcast(input: SendAlarmBroadcastInput) {
  return apiPost<AlarmBroadcastSendResponse>({
    path: '/alarm-broadcast/send',
    version: 'V2',
    body: {
      field_uid: input.field_uid,
      device_uid: input.device_uid,
      target_scope: input.target_scope,
      sacon_tx_type: input.sacon_tx_type,
      idempotency_key: input.idempotency_key ?? crypto.randomUUID(),
    },
  });
}
